import { render } from "./RiAccountProfile.vue?vue&type=template&id=d4f82c6e"
import script from "./RiAccountProfile.vue?vue&type=script&lang=js"
export * from "./RiAccountProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiAccountProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4f82c6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4f82c6e', __exports__)) {
    api.reload('d4f82c6e', __exports__)
  }
  
  module.hot.accept("./RiAccountProfile.vue?vue&type=template&id=d4f82c6e", () => {
    api.rerender('d4f82c6e', render)
  })

}


export default __exports__